import React, { PureComponent } from 'react';

import Container from 'react-bootstrap/Container';
import PropTypes from 'prop-types';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { Row, Col } from 'react-bootstrap';
import SelectNazione from '../RegistrationForm/SelectNazione';
import SelectProvincia from '../RegistrationForm/SelectProvincia';
import Modal from 'react-bootstrap/Modal';


import Labels_en from '../labels_en';
import Labels_it from '../labels_it';

import CzGlobals from '../global';

import axios from 'axios';


class RegistrationPage1 extends PureComponent {

  Labels = null;
  nextPage = null;

  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
      fldTitolo: null,
      fldNome: null,
      fldCognome: null,
      fldDataDiNascita: null,
      fldLuogoDiNascita: null,
      fldNazioneDiNascita: null, 
      fldTipo: null,
      fldProvincia: null,
      fldIndirizzo: null, 
      fldCap: null,
      fldCitta: null,
      fldSesso: null,
      fldNazioneIndirizzo: null,
      fldCf: null,
      showAlert: false,
      errorMessage: null
    };

    if (props.lang == "it") {
      this.Labels = Labels_it;
    } else {
      this.Labels = Labels_en;
    }

    this.nextPage = props.onNextPage;

    this.loadData();

  }

  loadData = () => {


    const formData = new FormData();

    var dati = {
      funzione: 'Carica'
    };

    var s = btoa(JSON.stringify(dati));

    formData.append('d', s);
    var me = this;
    const request = axios.post(CzGlobals.apisite + 'AJAXCliente.php', formData)
      .then(function (response) {
          var res = response.data;
          if (res.status=="OK") {
            me.setState({
              fldTitolo: res.titolo,
              fldNome: res.nome,
              fldCognome: res.cognome,
              fldDataDiNascita: res.nato_il,
              fldLuogoDiNascita: res.nato_a,
              fldNazioneDiNascita: res.nato_naz,
              fldTipo: res.tipo,
              fldProvincia: res.prov,
              fldIndirizzo: res.indirizzo, 
              fldCap: res.cap,
              fldSesso: res.sesso,
              fldCitta: res.citta,
              fldNazioneIndirizzo: res.nazione,
              fldCf: res.fiscale,
              showAlert: false,
              errorMessage: null
            });

            
          } else {
            return;
          }
      });




  }



  validateData = () => {

    var error = this.Labels.lbl_invalidField;
    var isErrorState = false;

    if (!this.state.fldNome) {
      isErrorState = true;
      error += this.Labels.lbl_Nome + ",";
    }
    if (!this.state.fldCognome) {
      isErrorState = true;
      error += this.Labels.lbl_Cognome + ",";
    }
    if (!this.state.fldDataDiNascita) {
      isErrorState = true;
      error += this.Labels.lbl_DataDiNascita + ",";
    }


    if (isErrorState) {
      this.setState({ showAlert: true, errorMessage: error });
      return;
    }


    const formData = new FormData();

    var dati = {
      funzione: 'pagina1',
      id_cliente: CzGlobals.id_cliente, 
      titolo: this.state.fldTitolo,
      nome: this.state.fldNome,
      cognome: this.state.fldCognome,
      tipo: this.state.fldTipo,
      sesso: this.state.fldSesso,
      nato_il: this.state.fldDataDiNascita,
      nato_a: this.state.fldLuogoDiNascita,
      nato_naz: this.state.fldNazioneDiNascita,
      prov: this.state.fldProvincia,
      indirizzo: this.state.fldIndirizzo,
      cap: this.state.fldCap,
      citta: this.state.fldCitta,
      nazione: this.state.fldNazioneIndirizzo,
      cf: this.state.fldCf,
    };

    var s = btoa(JSON.stringify(dati));

    formData.append('d', s);
    var me = this;
    const request = axios.post(CzGlobals.apisite + 'AJAXCliente.php', formData)
      .then(function (response) {
          var res = response.data;

          if (res.status=="OK") {
            CzGlobals.id_cliente = res.id_cliente;
            me.nextPage();
          } else {
            me.setState({ showAlert: true, errorMessage: res.descrizione });
            return;
          }
      });

  

  


    


  }

  handleCloseAlert = () => {
    this.setState({ showAlert: false });
  }

  componentWillMount = () => {
    console.log('RegistrationPage1 will mount');
  }

  componentDidMount = () => {
    console.log('RegistrationPage1 mounted');
  }

  componentWillReceiveProps = (nextProps) => {
    console.log('RegistrationPage1 will receive props', nextProps);
  }

  componentWillUpdate = (nextProps, nextState) => {
    console.log('RegistrationPage1 will update', nextProps, nextState);
  }

  componentDidUpdate = () => {
    console.log('RegistrationPage1 did update');
  }

  componentWillUnmount = () => {
    console.log('RegistrationPage1 will unmount');
  }

  render() {
    if (this.state.hasError) {
      return <h1>Something went wrong.</h1>;
    }
    return (
      <div className="RegistrationPage1Wrapper">
        <Card>
          <Card.Body>



            <Form>

              <Form.Row>
                <Form.Group as={Col} xs="6" lg="3" controlId="formGridName">
                  <Form.Row>
                    <Form.Label><b>{this.Labels.lbl_Tipo}</b></Form.Label>
                  </Form.Row>
                  <Form.Row>
                    <Form.Check name="formRegistration1Tipo" inline type="radio" checked={this.state.fldTipo==3} label={this.Labels.lbl_TipoAzienda} onChange={e => { var v = e.target.checked ? 3 : 2; this.setState({ fldTipo: v  })}} />
                    <Form.Check name="formRegistration1Tipo" inline type="radio" checked={this.state.fldTipo==2} label={this.Labels.lbl_TipoPersonale} onChange={e => { var v = e.target.checked ? 2 : 3; this.setState({ fldTipo: v  })}} />
                  </Form.Row>
                </Form.Group>

              </Form.Row>

              <Form.Row>
              <Form.Group as={Col} xs="2" lg="1" controlId="formGridName">
                  <Form.Label><b>{this.Labels.lbl_Titolo}</b></Form.Label>
                  <Form.Control placeholder="" value={this.state.fldTitolo} onChange={e => this.setState({ fldTitolo: e.target.value })} />
                </Form.Group>
                <Form.Group as={Col} controlId="formGridName">
                  <Form.Label><b>{this.Labels.lbl_Nome}</b></Form.Label>
                  <Form.Control placeholder="" value={this.state.fldCognome} onChange={e => this.setState({ fldNome: e.target.value })} />
                </Form.Group>
                <Form.Group as={Col} controlId="formGridDateOfBirth">
                  <Form.Label><b>{this.Labels.lbl_Cognome}</b></Form.Label>
                  <Form.Control placeholder="" value={this.state.fldNome} onChange={e => this.setState({ fldCognome: e.target.value })} />
                </Form.Group>
              </Form.Row>

              <Form.Row>

                <Form.Group as={Col} xs="6" lg="3" controlId="formGridSex">
                  <Form.Row>
                    <Form.Label><b>I am</b></Form.Label>
                  </Form.Row>
                  <Form.Row>
                    <Form.Check name="formRegistration1Sex" inline type="radio" checked={ (this.state.fldSesso=='m') } label={this.Labels.lbl_Uomo} onChange={e => { var v = e.target.checked ? 'm' : 'f'; this.setState({ fldSesso: v  })}} />
                    <Form.Check name="formRegistration1Sex" inline type="radio" checked={ (this.state.fldSesso=='f') } label={this.Labels.lbl_Donna} onChange={e => { var v = e.target.checked ? 'f' : 'm'; this.setState({ fldSesso: v  })}} />
                  </Form.Row>
                </Form.Group>

                <Form.Group as={Col} xs="12" lg="3" controlId="formGridDateOfBirth">
                  <Form.Row>
                    <Form.Label><b>{this.Labels.lbl_DataDiNascita}</b></Form.Label>
                  </Form.Row>
                  <Form.Row>
                    <Form.Control type="date" value={this.state.fldDataDiNascita} onChange={e => this.setState({ fldDataDiNascita: e.target.value })} />
                  </Form.Row>
                </Form.Group>

              </Form.Row>


              <Form.Row>
                <Form.Group as={Col} controlId="formPlaceOfBirth">
                  <Form.Label><b>{this.Labels.lbl_LuogoDiNascita}</b></Form.Label>
                  <Form.Control placeholder="" value={this.state.fldLuogoDiNascita} onChange={e => this.setState({ fldLuogoDiNascita: e.target.value })} />
                </Form.Group>

                <Form.Group as={Col} controlId="formGridAddress">
                  <Form.Label><b>{this.Labels.lbl_StatoDiNascita}</b></Form.Label>
                  <SelectNazione value={ this.state.fldNazioneDiNascita } onChangeSelect={valore => this.setState({ fldNazioneDiNascita: valore })} />
                </Form.Group>
              </Form.Row>

              <Form.Row>

                <Form.Group as={Col} xs="4" lg="2">
                  <Form.Label><b>{this.Labels.lbl_CF}</b></Form.Label>
                  <Form.Control placeholder="" value={ this.state.fldCf } onChange={e => this.setState({ fldCf: e.target.value })} />
                </Form.Group>

                {/*
                 <Form.Group as={Col} xs="4" lg="2">
                  <Form.Label><b>{this.Labels.lbl_IVA}</b></Form.Label>
                  <Form.Control placeholder="" />
                </Form.Group>  */}

              </Form.Row> 

              <Form.Group controlId="formGridAddress">
                <Form.Label><b>{this.Labels.lbl_Indirizzo}</b></Form.Label>
                <Form.Control placeholder="" value={this.state.fldIndirizzo} onChange={e => this.setState({ fldIndirizzo: e.target.value })} />
              </Form.Group>



              <Form.Row>

                <Form.Group as={Col} xs="6" md="4" controlId="formGridCity">
                  <Form.Label><b>{this.Labels.lbl_City}</b></Form.Label>
                  <Form.Control value={this.state.fldCitta} onChange={e => this.setState({ fldCitta: e.target.value })} />
                </Form.Group>

                <Form.Group as={Col} xs="6" md="4" controlId="formGridZip">
                  <Form.Label><b>{this.Labels.lbl_Zip}</b></Form.Label>
                  <Form.Control value={this.state.fldCap} onChange={e => this.setState({ fldCap: e.target.value })} />
                </Form.Group>

                <Form.Group as={Col} xs="6" md="4" controlId="formGridZip">
                  <Form.Label><b>{this.Labels.lbl_Provincia}</b></Form.Label>
                  <SelectProvincia value={ this.state.fldProvincia } onChangeSelect={valore => this.setState({ fldProvincia: valore })}></SelectProvincia>
                </Form.Group>

                <Form.Group as={Col} xs="6" md="4" controlId="formGridState">
                  <Form.Label><b>{this.Labels.lbl_State}</b></Form.Label>
                  <SelectNazione value={ this.state.fldNazioneIndirizzo }  onChangeSelect={valore => this.setState({ fldNazioneIndirizzo: valore })}></SelectNazione>
                </Form.Group>

              </Form.Row>

              <Button variant="primary" type="button" onClick={this.validateData}>
                {this.Labels.lbl_VaiAPagina2}
              </Button>

            </Form>

          </Card.Body>
        </Card>

        <Modal
          show={this.state.showAlert}
          onHide={this.handleCloseAlert} 
          //  backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.Labels.lbl_titoloMsgErrore}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.errorMessage}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseAlert}>
              Close
          </Button>
            <Button variant="primary">Understood</Button>
          </Modal.Footer>
        </Modal>


      </div >
    );
  }
}

RegistrationPage1.propTypes = {
  // bla: PropTypes.string,
};

RegistrationPage1.defaultProps = {
  // bla: 'test',
};





export default RegistrationPage1;
